import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { Product } from '../../domain/product'
import { ProductService } from '../products/product.service'
import { SITE_TITLE } from '../../shared/constants'
import { UiUtil } from '../../util/ui-util'

@Component({
  selector: 'app-products-detail',
  imports: [],
  templateUrl: './products-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './products-detail.component.scss'
})
export class ProductsDetailComponent implements OnInit {
  constructor(private meta: Meta, private title: Title,
    private productsService: ProductService
  ) { }

  slug: string = ""
  product: Product = new Product()

  ngOnInit() {
    this.slug = UiUtil.getLastPartOfUrl()?.toString() || ""

    var products = this.productsService.getProducts()
    for (var i = 0; i < products.length; i++) {
      if (this.slug == products[i].slug) {
        this.product = products[i]
        break;
      }
    }

    this.title.setTitle(this.product.title || SITE_TITLE + ' | ' + this.product.name)
    this.meta.updateTag({ name: 'description', content: this.product.metaDescription || this.product.name })
    this.meta.updateTag({ name: 'keywords', content: this.product.keywords })

  }
}
